<template>
  <p
    class="badge text-body-small box-border flex max-h-5 min-h-5 w-fit items-center gap-1 rounded-full border px-2 leading-0 font-medium text-nowrap"
    :data-variant="variant"
    :class="{
      '!bg-badge-bgr-default-strong !text-badge-fgr-default-strong !border-badge-bdr-default-default':
        variant === BadgeVariant.Default && strong,
      '!bg-badge-bgr-accent-strong !text-badge-fgr-accent-strong !border-badge-bdr-accent-default':
        variant === BadgeVariant.Info && strong,
      '!bg-badge-bgr-critical-strong !text-badge-fgr-critical-strong !border-badge-bdr-critical-default':
        variant === BadgeVariant.Danger && strong,
      '!bg-badge-bgr-success-strong !text-badge-fgr-success-strong !border-badge-bdr-success-default':
        variant === BadgeVariant.Success && strong,
      '!bg-badge-bgr-warning-strong !text-badge-fgr-warning-strong !border-badge-bdr-warning-default':
        variant === BadgeVariant.Warning && strong,
      '!bg-badge-bgr-brown-strong !text-badge-fgr-brown-strong !border-badge-bdr-brown-default':
        variant === BadgeVariant.Brown && strong,
      '!bg-fgr-warning !border-fgr-warning !text-white': variant === BadgeVariant.Orange && strong,
      '!bg-badge-bgr-purple-strong !text-badge-fgr-purple-strong !border-badge-bdr-purple-default':
        variant === BadgeVariant.Purple && strong,
      '!bg-badge-bgr-default-default !text-badge-fgr-default-default !border-none': variant === BadgeVariant.Grey,
      '!bg-badge-bgr-teal-strong !text-badge-fgr-teal-strong !border-badge-bdr-teal-default':
        variant === BadgeVariant.Teal && strong,
      '!text-badge-fgr-default-default !border-badge-bdr-default-default': variant === BadgeVariant.Default && !strong,
      '!text-badge-fgr-accent-default !border-badge-bdr-accent-default': variant === BadgeVariant.Info && !strong,
      '!text-badge-fgr-critical-default !border-badge-bdr-critical-default': variant === BadgeVariant.Danger && !strong,
      '!text-badge-fgr-success-default !border-badge-bdr-success-default': variant === BadgeVariant.Success && !strong,
      '!text-badge-fgr-warning-default !border-badge-bdr-warning-default': variant === BadgeVariant.Warning && !strong,
      '!text-badge-fgr-brown-default !border-badge-bdr-brown-default': variant === BadgeVariant.Brown && !strong,
      '!text-badge-fgr-orange-default !border-badge-bdr-orange-default': variant === BadgeVariant.Orange && !strong,
      '!text-badge-fgr-purple-default !border-badge-bdr-purple-default': variant === BadgeVariant.Purple && !strong,
      '!text-badge-fgr-teal-default !border-badge-bdr-teal-default': variant === BadgeVariant.Teal && !strong,
      '!bg-bgr-tertiary !text-fgr-placeholder !border-bgr-tertiary': variant === BadgeVariant.Grey,
    }"
  >
    <Icon v-if="icon" :src="icon" :size="ComponentSize.sm" />
    <slot />
  </p>
</template>
<script setup lang="ts">
  defineOptions({
    name: "Badge",
  });

  withDefaults(
    defineProps<{
      variant?: BadgeVariant;
      strong?: boolean;
      icon?: string;
    }>(),
    {
      variant: BadgeVariant.Default,
      strong: true,
      icon: "",
    }
  );
</script>
